import type { ReactElement } from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface DisconnectSiemDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  readOnly?: boolean;
}

export function DisconnectSiemDialog({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  readOnly,
}: DisconnectSiemDialogProps): ReactElement {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Disconnect SIEM?</AlertDialogTitle>
          <AlertDialogDescription>
            This will stop forwarding security events to your SIEM. You can
            reconnect at any time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <Button
            onClick={onConfirm}
            disabled={isLoading || (readOnly ?? false)}
            variant="destructive"
          >
            {isLoading ? 'Disconnecting...' : 'Disconnect'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
